import React from 'react';
import useTranslation from 'utils/hooks/useTranslation';

import css from '../Startseite.module.scss';

const DataInfo: React.FC = () =>
{
  const { t } = useTranslation();
  return (
    <div className={css.dataInfo}>
      <h3>{t('startseite:dataInfo.heading')}</h3>
      <ul>
          {(t('startseite:dataInfo.list', { returnObjects: true }) as string[]).map((item) => (
          <li key={item}>{item}</li>
          ))}
      </ul>
    </div>
  );
};

export default DataInfo;
